export default "__VITE_ASSET__BzCmxSvv__"